<div class="reservation-container">
    <div class="reservation-header">
        <div class="header-left">
            <img src="assets/images/icons/dashboard/shield_check_red.png" alt="shield_check_red Icon" class="file-icon">
            <span class="header-title">
                <span class="title-text">Réservations / <strong>{{ isEditMode ? 'Modifier l\'offre' : 'Créer une nouvelle offre' }}</strong></span>
            </span>
        </div>

        <div class="header-right">
            <button class="back-btn" (click)="onCancel()">
                <img src="assets/images/icons/back-arrow.png" alt="back" class="add-icon">
                <span>Retour</span>
            </button>
        </div>
    </div>

    <div class="reservation-details-container">
        <!-- Loading state -->
        <div *ngIf="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Chargement des données...</p>
        </div>

        <!-- Error state -->
        <div *ngIf="!isLoading && errorMessage" class="error-state">
            <div class="error-icon">!</div>
            <p class="error-message">{{ errorMessage }}</p>
            <button class="btn-primary" (click)="onCancel()">Retour à la liste</button>
        </div>

        <div *ngIf="!isLoading && reservation && !errorMessage" class="reservation-card-container">
            <div class="reservation-card-container">
                <div class="reservation-card">
                    <div class="reservation-image-col">
                        <img [src]="'./assets/images/icons/file_check_card.png'" [alt]="reservation.eventName" class="reservation-image">
                    </div>

                    <div class="reservation-content-col">
                        <div class="col-header">
                            <h3 class="reservation-title"><strong>{{ reservation.eventName }}</strong> / {{ reservation.client.firstName }}</h3>
                            <div class="right-side">
                                <button class="create-offer-btn"><img src="./assets/images/icons/suitcase.png" alt="suitcase"><span>Créé une offre</span></button>
                                <div class="status-badge">
                                    <!--<span class="status-dot" [class.public]="member.isEnabled" [class.private]="!member.isEnabled"></span>
                                        <span class="status-text">{{ member.isEnabled ? 'Activer' : 'Inactive' }}</span>-->
                                </div>
                            </div>
                        </div>

                        <div class="reservation-footer">
                            <div class="info-col">
                                <div class="data">
                                    <img src="./assets/images/icons/user_card_id_gray.png" alt="user_card_id icon"><span>{{ reservation.requiredAgents }}</span>
                                </div>
                                <div class="data">
                                    <img src="./assets/images/icons/calendar_calendar_event_gray.png" alt="calendar_calendar_event_gray icon"><span>{{ reservation.startDateTime }}</span>
                                </div>
                                <div class="data">
                                    <img src="./assets/images/icons/map_pin_gray.png" alt="map_pin_gray icon"><span>{{ formatAddress(reservation.address) }}</span>
                                </div>
                            </div>
                            <div class="creation-date">
                                {{ reservation.createdAt }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Form -->
        <form [formGroup]="offerForm" (ngSubmit)="onSubmit()" class="offer-form">
            <!-- Price Field -->
            <div class="form-group mb-4">
                <div class="input-group">
                    <span class="input-group-text">
                        €
                    </span>
                    <input type="number" id="price" formControlName="price" class="form-control" [class.is-invalid]="offerForm.get('price')?.invalid && offerForm.get('price')?.touched" step="0.01" min="0.01" placeholder="0.00" />
                </div>
                <div *ngIf="offerForm.get('price')?.invalid && offerForm.get('price')?.touched" class="form_error d-block">
                    {{ getErrorMessage('price') }}
                </div>
                <small class="help-text">
                    Entrez le prix total de l'offre en euros.
                </small>
            </div>

            <!-- Description Field -->
            <div class="form-group mb-4">
                <textarea id="description" formControlName="description" class="form-control" [class.is-invalid]="offerForm.get('description')?.invalid && offerForm.get('description')?.touched" rows="4" placeholder="Décrivez les détails de l'offre, les services inclus, etc."></textarea>
                <div *ngIf="offerForm.get('description')?.invalid && offerForm.get('description')?.touched" class="invalid-feedback d-block">
                    {{ getErrorMessage('description') }}
                </div>
                <div class="d-flex justify-content-between mt-1">
                    <small class="help-text">
                        Minimum 10 caractères, maximum 500 caractères.
                    </small>
                    <small [class.text-danger]="offerForm.get('description')?.value?.length > 500" class="help-text">
                        {{ offerForm.get('description')?.value?.length || 0 }}/500
                    </small>
                </div>
            </div>

            <!-- Agents Selection -->
            <div class="form-group mb-4">
                <label class="help-text">
                    Sélection des agents <span class="text-danger">*</span>
                </label>

                <!-- Agents Selection Info -->
                <div class="agents-selection-info">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <strong>Sélectionnés:</strong> {{ selectedAgentIds.length }} / {{ reservation.requiredAgents }}
                            <span *ngIf="remainingAgents > 0" class="ms-2">
                                ({{ remainingAgents }} agent{{ remainingAgents > 1 ? 's' : '' }} restant{{ remainingAgents > 1 ? 's' : '' }})
                            </span>
                            <span *ngIf="isMaxAgentsSelected" class="ms-2">
                                <i class="fa fa-check-circle"></i> Nombre d'agents requis atteint
                            </span>
                        </div>
                        <div *ngIf="selectedAgentIds.length > 0" class="">
                            <i class="fa fa-person-check"></i> {{ getSelectedAgents().length }} agent{{ getSelectedAgents().length > 1 ? 's' : '' }} sélectionné{{ getSelectedAgents().length > 1 ? 's' : '' }}
                        </div>
                    </div>
                </div>

                <!-- Agents Filter -->
                <div class="agents-filter-section mb-3">
                    <div class="row g-2">
                        <div class="col-md-6">
                            <div class="input-group">
                                <span class="input-group-text">
                                    <img src="./assets/images/icons/input_search.png" alt="input_search">
                                </span>
                                <input type="text" class="form-control" [(ngModel)]="searchTerm" (ngModelChange)="filterAgents()" [ngModelOptions]="{standalone: true}" placeholder="Rechercher par nom ou email..." />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <select class="form-select custom-select" [(ngModel)]="specializationFilter" (ngModelChange)="filterAgents()" [ngModelOptions]="{standalone: true}">
                                <option value="">Toutes les spécialisations</option>
                                <option *ngFor="let spec of specializations" [value]="spec">
                                {{ spec }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <!-- Selected Agents Preview -->
                <div *ngIf="selectedAgentIds.length > 0" class="selected-agents-preview mb-3">
                    <div class="selected-agents-list">
                        <div *ngFor="let agent of getSelectedAgents()" class="selected-agent-badge badge me-2 mb-2">
                            {{ agent.fullName }}
                            <button type="button" class="btn-close btn-close-white" (click)="toggleAgentSelection(agent.id)" aria-label="Retirer">
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Available Agents List -->
                <div class="available-agents-list" [class.is-invalid]="offerForm.get('agentIds')?.invalid && offerForm.get('agentIds')?.touched">
                    <div class="agents-grid">
                        <div *ngFor="let agent of filteredAgents" class="agent-card" [class.selected]="isAgentSelected(agent.id)" [class.disabled]="!isAgentSelected(agent.id) && isMaxAgentsSelected">
                            <div class="agent-card-content">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" [id]="'agent-' + agent.id" [checked]="isAgentSelected(agent.id)" (change)="toggleAgentSelection(agent.id)" [disabled]="!isAgentSelected(agent.id) && isMaxAgentsSelected" />
                                    <label class="form-check-label" [for]="'agent-' + agent.id">
                                        <div class="agent-info">
                                        <h6 class="agent-name">{{ agent.fullName }}</h6>
                                        <div class="agent-details">
                                            <span class="agent-specialization" title="spécialisation">
                                                <em class="fa fa-tags"></em> {{ agent.specialization || 'Non spécifié' }}
                                            </span>
                                            <span class="agent-rating" title="notation">
                                                <em class="fa fa-star"></em> {{ agent.rating || 'N/A' }}/5
                                            </span>
                                            <span class="agent-experience" title="années d'expérience">
                                                <em class="fa fa-briefcase"></em> {{ agent.yearsOfExperience || 0 }} ans
                                            </span>
                                        </div>
                                        <div class="agent-details">
                                            <span class="agent-age" title="age">
                                                <em class="fa-solid fa-user-clock"></em> {{ agent.age || 0 }} ans
                                            </span>
                                             <span class="agent-age" title="hauteur">
                                                <em class="fa-solid fa-arrows-up-down"></em> {{ agent.height || 0 }} cm
                                            </span>
                                             <span class="agent-age" title="poids">
                                                <em class="fa-solid fa-dumbbell"></em> {{ agent.weight || 0 }} kg
                                            </span>
                                        </div>
                                        <div class="agent-details" *ngIf="agent.address">
                                            <span class="agent-age" title="age">
                                                <em class="fa-solid fa-location-dot"></em> {{ formatAddress(agent.address) }}
                                            </span>
                                        </div>
                                        <div class="agent-status">
                                            <span class="badge" 
                                                [class.bg-success]="agent.isAvailable"
                                                [class.bg-danger]="!agent.isAvailable">
                                                {{ agent.isAvailable ? 'Disponible' : 'Indisponible' }}
                                            </span>
                                            <span class="agent-rate" title="taux horaire">
                                                {{ (agent.hourlyRate | priceFormat) || 'N/A' }} €/h
                                            </span>
                                        </div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="filteredAgents.length === 0" class="no-agents-message text-center py-4">
                        <i class="bi bi-person-x display-4 text-muted"></i>
                        <p class="mt-2">Aucun agent trouvé avec les critères de recherche</p>
                    </div>
                </div>

                <!-- Agents Error Message -->
                <div *ngIf="offerForm.get('agentIds')?.invalid && offerForm.get('agentIds')?.touched" class="invalid-feedback d-block mt-2">
                    {{ getErrorMessage('agentIds') }}
                </div>
            </div>

            <!-- Form Actions -->
            <div class="form-actions">
                <button type="submit" class="btn-primary" [disabled]="offerForm.invalid || isSubmitting">
                    <span *ngIf="isSubmitting">
                        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            Traitement...
                    </span>
                    <span *ngIf="!isSubmitting">
                        {{ isEditMode ? 'Mettre à jour' : 'Créer l\'offre' }}
                    </span>                  
                </button>
                <button type="button" class="btn-cancel" (click)="onCancel()" [disabled]="isSubmitting">
                    Annuler
                </button>
            </div>
        </form>

    </div>

</div>